import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Branding from 'shared/branding'
import { BENEFITS_BOX_WIDGET } from 'constants/values'

function BenefitsWidget (props) {
  const { provider } = props
  const { key } = Branding.current
  const { businessUnitID, brandID, boxColor, dataToken } = BENEFITS_BOX_WIDGET?.[provider]?.[key] || {}
  const widgetRef = useRef(null)

  useEffect(() => {
    if (!widgetRef.current || !businessUnitID) return

    if (provider === 'TRUSTPILOT') {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(widgetRef.current, true)
        return
      }

      const handleLoad = () => {
        if (window.Trustpilot && widgetRef.current) {
          window.Trustpilot.loadFromElement(widgetRef.current, true)
        }
      }

      window.addEventListener('load', handleLoad)
      return () => {
        window.removeEventListener('load', handleLoad)
      }
    } else {
      const existingScript = document.getElementById('amplify-widget-script')
      if (existingScript) {
        existingScript.remove()
      }

      const script = document.createElement('script')
      script.id = 'amplify-widget-script'
      script.src = 'https://amplify.review-alerts.com/widget-init.js'
      script.async = false
      script.dataset.status = 'loading'

      script.onload = () => {
        script.dataset.status = 'loaded'
      }
      script.onerror = () => {
        script.remove()
      }

      document.head.appendChild(script)
    }
  }, [provider, businessUnitID])

  if (!businessUnitID) {
    return null
  }

  if (provider === 'TRUSTPILOT') {
    return (
      <div
        key="trustpilot-widget"
        ref={widgetRef}
        className="trustpilot-widget pl-3"
        style={{ pointerEvents: 'none', cursor: 'default', width: '76%', margin: '0 auto' }}
        data-locale="en-US"
        data-template-id="53aa8807dec7e10d38f59f32"
        data-businessunit-id={businessUnitID}
        data-style-height="120px"
        data-style-width="100%"
        data-theme="light"
        data-tags="SelectedReview"
      >
        <p>Trustpilot</p>
      </div>
    )
  }
  return (
    <div
      key="amplify-widget"
      ref={widgetRef}
      className="amplify-widget"
      style={{
        '--benefits-widget-bg': boxColor,
        backgroundColor: boxColor,
      }}
      data-token={dataToken}
      data-widget-id={businessUnitID}
      data-widget-type="star_snapshot"
      data-external-id={brandID}
    />
  )
}

BenefitsWidget.propTypes = {
  provider: PropTypes.oneOf(['TRUSTPILOT', 'RIO']).isRequired,
}

export { BenefitsWidget }
